import {
	DELETE,
	FETCH,
	POST,
	PUT,
	GOT_RESPONSE,
	ERROR,
	CLEAR_MYTOUR,
	CLEAR_ME,
	UPLOAD_FILE_TO_S3,
	CLEAR_PRESIGNED_IMAGE_URLS,
	LOCAL_EDIT_TOURGUIDE,
} from './constants';

export const doFetch = (dataType, path, access_token) => ({
	type: FETCH,
	dataType,
	path,
	access_token,
})

export const doPost = (dataType, path, access_token, data, navigate) => ({
	type: POST,
	dataType,
	path,
	access_token,
	data,
	navigate,
})

export const doPut = (dataType, path, access_token, data, navigate) => ({
	type: PUT,
	dataType,
	path,
	access_token,
	data,
	navigate,
})

export const doDelete = (dataType, path, access_token, navigate) => ({
	type: DELETE,
	dataType,
	path,
	access_token,
	navigate,
})

export const gotResponse = (responseType, response) => ({
	type: GOT_RESPONSE,
	responseType,
	response,
})

export const apiError = (error) => ({
	type: ERROR,
	error,
})

export const clearMyTour = () => ({
	type: CLEAR_MYTOUR,
})

export const clearMe = () => ({
	type: CLEAR_ME,
})

export const s3upload = (files, presignedUrls) => ({
	type: UPLOAD_FILE_TO_S3,
	files,
	presignedUrls
})

export const clearPresignedImages = () => ({
	type: CLEAR_PRESIGNED_IMAGE_URLS,
})

export const localEditTourguide = (tourguide) => ({
	type: LOCAL_EDIT_TOURGUIDE,
	tourguide,
})